export default __webpack_public_path__ + "static/media/discoverableonnetwork.f641c86c.png";